import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../../../shared/form-elements/input';
import SelectField from '../../../../shared/form-elements/select/field';
import DatePicker from '../../../../shared/date-picker/main';
import CheckboxField from '../../../../shared/form-elements/checkbox';

const Main = props => {
	return (
		<div className=''>
			<form
				onSubmit={props.handleSubmit(data => props.submitForm(data))}
				className='ui-form clearfix'
			>
				<div className="ui-form__element">
					<Field
						name="start"
						intl={props.intl}
						onUpdate={props.datepickerChange}
						{...props.datepicker}
						component={DatePicker}
						onToggle={props.datepickerToggle}
						onApply={props.datepickerApply}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="affiliate_id"
						placeholder={props.intl('Select affiliate')}
						multi={false}
						options={props.affiliatesLookup}
						onChange={props.handleAffiliateChange}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="offer_id"
						placeholder={props.intl('Select offer')}
						multi={false}
						onChange={props.handleOfferChange}
						options={props.offersLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="country_id"
						placeholder={props.intl('Select country')}
						multi={false}
						options={props.locationsLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="campaign_id"
						placeholder={props.intl('Campaign id')}
						multi={false}
						options={props.campaignsLookup}
						component={SelectField}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="sids"
						placeholder={props.intl('Sid')}
						component={InputField}
						showLabel={true}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="traffic_source"
						placeholder={props.intl('Traffic source')}
						searchable={false}
						component={SelectField}
						options={props.formSelectOptions.traffic_source}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="target_percent"
						component={InputField}
						showLabel={true}
						placeholder={props.intl('Target approve percent')}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="count_approved_condition"
						component={InputField}
						showLabel={true}
						placeholder={props.intl('Count approved condition')}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="is_limited"
						component={CheckboxField}
						showLabel={true}
						placeholder={props.intl('Limited?')}
					/>
				</div>
				<FieldArray name="start_leads_setting" component={StartLeads} {...props} />
				<div className="ui-form__element">
					<Field
						name="duration"
						searchable={false}
						component={SelectField}
						placeholder={props.intl('Duration')}
						options={props.formSelectOptions.duration}
					/>
				</div>
				{
					!!Number(props.error) &&
					<div className="margin-10-0">
						{`You are trying to create duplicate of `}
						<Link to={`/guarant-approve-requests/edit/${props.error}`} className="link">
							Existing garant
						</Link>
					</div>
				}
				<div className=''>
					<div className='ui-form__element buttons-wrap'>
						<button className='ui-btn ui-btn-primary' type="submit">
							{props.intl('Save')}
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

const StartLeads = props => {
	if (!props.fields.length) {
		return <button
			onClick={ () => props.fields.push({})}
			className="ui-btn ui-btn-primary"
			type="button"
		>
			Add start leads setting
		</button>;
	} else {
		return (
			<div>
				{
					props.fields.map((parentName, index) =>
						<div  key={index} className="display-flex">
							<div className="ui-form__element">
								<Field
									name={`${parentName}.start_leads_count`}
									component={InputField}
									showLabel={true}
									placeholder={props.intl('Start leads count')}
								/>
							</div>
							<div className="ui-form__element margin-0-10 width-150">
								<Field
									name={`${parentName}.start_duration`}
									searchable={false}
									component={SelectField}
									placeholder={props.intl('Duration')}
									options={props.formSelectOptions.duration}
								/>
							</div>
							<a className="action_edit" onClick={e => {
								e.preventDefault();
								props.fields.remove(index);
							}}/>
						</div>)
				}
				<button
					onClick={ () => props.fields.push({})}
					className="ui-btn ui-btn-primary"
					type="button"
				>
					+ Add start leads setting
				</button>
			</div>
		);
	}
};

export default reduxForm({ form: 'manualGuarantRequests', enableReinitialize: true })(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants/editor/components/form/main.js